import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PlayerNotifyComponent } from '@splixer/player-ui';

@Component({
  selector: 'kmhd-root-page',
  templateUrl: 'root.page.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PlayerNotifyComponent,
    RouterOutlet
  ]
})
export class KmhdRootPage {
  constructor() {
    console.info('Build 2026.05.20-1');
  }
}
